import axios from './axyos';
import type { CountryValue } from '../features/country/countrySlice';

export interface CaptchaPayload {
    input: string;
    code: string;
    proof: string;
}

interface registerData {
    id?: string | null,
    email: string,
    password?: string,
    lastName: string,
    firstName: string,
    status: string,
    nbr_child?: number,
    phone: string,
    codeCountry: string,
    indicatif: string,
    country: CountryValue,
    captcha?: CaptchaPayload,
}

export const registerApi = (data: registerData) => {
    return axios.post('/signup', data);
};
